<!--
 * @Author: 孙照
 * @LastEditTime: 2024-01-02 19:40:38
 * @Description: 一级弹框
 * @FilePath: \sheyang\src\components\pubMainModal\index.vue
-->
<template>
  <div class="pub-main-modal" v-if="visible">
    <div class="modal-mask">
      <div v-if="!isRank" class="modal-close" @click.stop="closeVisible(false)">
        <img src="@/assets/images/modalCloseIcon.png" alt="">
      </div>
      <div v-else class="modal-close-rank" @click.stop="closeVisible(false)">
        <img src="@/assets/images/modalCloseIcon.png" alt="">
      </div>
      <div class="modal-content" :class="nobg ? 'modal-no-bg' : ''">
        <slot name="content"></slot>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'pubMainModal',
  props: {
    isRank: {
      default: false,
      type: Boolean,
    },
    visible: {
      default: false,
      type: Boolean,
    },
    nobg: {
      default: false,
      type: Boolean,
    },
  },
  watch: {
    visible: {
      handler(newVal, oldVal) {
        // Web 端滚动穿透问题
        const body = document.getElementsByTagName('html')[0];
        body.style.overflow = newVal ? 'hidden' : 'auto';
        body.style.position = newVal ? 'fixed' : 'static';
      },
      immediate: true,
    },
  },
  methods: {
    closeVisible(flag) {
      this.$emit('change-visible', flag);
    },
  },
};
</script>

<style lang="less" scoped>
.pub-main-modal {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: auto;
  z-index: 88;
  // &::-webkit-scrollbar { width: 0 !important }
  .modal-mask {
    z-index: 88;
    width: 1920px;
    height: 1080px;
    background: rgba(0,0,0,0.6);
    position: relative;
    .modal-close {
      z-index: 88;
      width: 30px;
      height: 30px;
      position: absolute;
      top: 20px;
      right: 50px;
      cursor: pointer;
      img {
        z-index: 88;
        width: 30px;
        height: 30px;
      }
    }
    .modal-close-rank {
      z-index: 88;
      width: 30px;
      height: 30px;
      position: absolute;
      top: 20px;
      right: 350px;
      cursor: pointer;
      img {
        z-index: 88;
        width: 30px;
        height: 30px;
      }
    }
    .modal-content {
      z-index: 89;
      position: absolute;
      top: 60px;
      left: 50%;
      transform: translateX(-50%);
      width: 1880px;
      height: 1003px;
      .backgroundImage('@/assets/images/mainDialogBg.png');
    }

    .modal-no-bg {
      background: none;
    }

  }
}
</style>
